import { RouteConfig } from 'vue-router';

import TermsAdd from '@/views/terms/Edit.vue';

export const termsAddRoute: RouteConfig = {
  path: 'add',
  name: 'termsAdd',
  component: TermsAdd,
  meta: {
    breadcrumb: {
      title: 'breadcrumbs.terms.add'
    }
  }
};
